import { isDev } from "@/lib/chillnn/enviroment";

const supportSiteBase = isDev ? "https://dev-support.chillnn.com" : "https://support.chillnn.com";
const ANNOUNCEMENTS_URL = `${supportSiteBase}/announcements.json`;

export type SupportAnnouncement = {
	title: string;
	href: string;
	categoryLabel: string;
	thumbnailUrl: string | null;
	/** 記事の frontmatter に無ければ配信側が省略する */
	publishedAt?: string;
	updatedAt?: string;
	content: string;
};

/**
 * support の公開JSONからお知らせを取得する。本文は管理画面のモーダル表示に使う。
 * HTTPエラーは呼び出し側へ伝え、取得失敗を正常な0件と区別する。
 */
export const fetchSupportAnnouncements = async (signal: AbortSignal): Promise<SupportAnnouncement[]> => {
	const res = await fetch(ANNOUNCEMENTS_URL, { signal });
	if (!res.ok) throw new Error(`お知らせの取得に失敗しました: ${res.status} ${ANNOUNCEMENTS_URL}`);

	const data = (await res.json()) as { items?: SupportAnnouncement[] };
	return data.items ?? [];
};
